export default "__VITE_ASSET__DPxINoJ$__"